import { render, staticRenderFns } from "./MotorbikeData.vue?vue&type=template&id=4dd720eb"
import script from "./MotorbikeData.vue?vue&type=script&lang=ts"
export * from "./MotorbikeData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports